import { useState } from "react"

import { Badge } from "@minuthq/meatball-ui-react"

import { ParadiseLLMPromptVersionDialog } from "src/components/Paradise/ParadiseLLMPrompts/ParadiseLLMPromptDetails/ParadiseLLMPromptVersionDialog"
import { ParadiseTable } from "src/components/Paradise/ParadiseTable"
import {
  TruncatedEntityId,
  TruncatedUserId,
} from "src/components/Paradise/ParadiseTruncatedIds"
import { StatusWrapper } from "src/components/Paradise/sharedStyles"
import {
  TParadiseLLMPrompt,
  TParadiseLLMPromptVersion,
} from "src/data/paradise/paradiseLLMPrompts/types/paradiseLLMPromptsQueryTypes"
import { Routes } from "src/router/routes"
import { useTableColumns } from "src/ui/GridTable/useTableColumns/useTableColumns"
import { formatUtcDate } from "src/utils/l10n"

export function ParadiseLLMPromptVersions({
  prompt,
}: {
  prompt: TParadiseLLMPrompt
}) {
  const [selectedVersion, setSelectedVersion] =
    useState<TParadiseLLMPromptVersion | null>(null)

  const reversedVersions = prompt.versions.toReversed()

  const { headerElements, rows, templateColumns } = useTableColumns<
    (typeof prompt.versions)[0]
  >({
    columns: [
      {
        value: "id",
        label: "Version id",
        renderCell: (data, i) => (
          <div>
            <StatusWrapper>
              <TruncatedEntityId
                entityId={data.id}
                entityName="Version"
                textVariant="nano"
              />
              {i === 0 && (
                <Badge color="info" size="x-small">
                  active
                </Badge>
              )}
            </StatusWrapper>
          </div>
        ),
        columnWidth: "min-content",
      },
      {
        value: "description",
        label: "Description",
        renderCell: (data) => <div>{data.description || "-"}</div>,
        columnWidth: "1fr",
      },
      {
        value: "created_at",
        label: "Created at",
        renderCell: (data) => (
          <div>{formatUtcDate({ date: data.created_at })}</div>
        ),
        columnWidth: "min-content",
      },
      {
        value: "created_by",
        label: "Created by",
        renderCell: (data) => (
          <TruncatedUserId
            userId={data.created_by}
            to={Routes.ParadiseUser.location(data.created_by)}
            textVariant="bodyS"
          />
        ),
        columnWidth: "min-content",
      },
    ],
    data: reversedVersions,
  })

  return (
    <>
      <ParadiseTable
        header={headerElements}
        rows={rows ?? []}
        templateColumns={templateColumns}
        onRowClick={(index) => {
          const version = reversedVersions[index]

          if (version) {
            setSelectedVersion(version)
          }
        }}
      />

      {!!selectedVersion && (
        <ParadiseLLMPromptVersionDialog
          onClose={() => setSelectedVersion(null)}
          version={selectedVersion}
          promptId={prompt.id}
        />
      )}
    </>
  )
}
